import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { withTheme } from 'styled-components';
import { TrashBinIcon, PaperPlaneIcon } from '@rsos/assets/icons';
import { CheckBox, Box } from '@rsos/components/capstone/base';
import { createAppUser } from '@rsos/sinatra';
import { notifySuccess, notifyError } from '@rsos/utils/toastUtils';
import { GENERIC_REQUEST_ERROR_MESSAGE } from '../../../constants/defaultErrorMessages';
import { NAME, EMAIL, ROLE, LAST_ACTIVE } from '../../../constants/userHeaders';
import NoSearchResult from '../NoSearchResult';
import NoUsers from '../NoUsers';
import UsersList from '../UsersList';
import {
  UserContent,
  UserTHead,
  UserTData,
  UsersTable,
  IconWrapper,
  Container,
  CustomToolTip,
  TooltipChild,
} from '../styles/Users.styles';
import { SortIconWrapper } from './SortIconWrapper';

const UsersContainer = withTheme(
  ({
    orgID,
    searchTerm,
    application,
    currentPSAPUsers,
    toggleEditUserModal,
    isSelectedAllChecked,
    toggleDeleteUserModal,
    handleSelectedAllChecked,
    handleCheckboxChange,
    values,
    setValues,
    arrayHelpers,
    sortPSAPUsers,
    shouldReverse,
    sortedByValue,
  }) => {
    const dispatch = useDispatch();
    const [, setIsLoading] = useState(false);

    const handleResentInvite = () => {
      if (values.users.length) {
        setIsLoading(true);
        values.users.forEach(user => {
          const userInfo = {
            role: user.role,
            email: user.email,
            application: application,
            last_name: user.last_name,
            first_name: user.first_name,
          };
          dispatch(createAppUser(orgID, application, userInfo))
            .then(() => {
              notifySuccess('Invite has been resent');
            })
            .catch(action => {
              const errorMessage = action?.error?.message;
              notifyError(
                errorMessage ? errorMessage : GENERIC_REQUEST_ERROR_MESSAGE,
              );
            })
            .finally(() => setIsLoading(false));
        });
      }
    };

    return (
      <Container>
        <UsersTable>
          <UserTHead>
            <UserContent>
              <UserTData>
                <CheckBox
                  noText
                  isChecked={isSelectedAllChecked}
                  disabled={!currentPSAPUsers.length}
                  onChange={() => handleSelectedAllChecked(values, setValues)}
                />
              </UserTData>
            </UserContent>
            <UserContent>
              <UserTData
                clickable
                onClick={() => sortPSAPUsers(currentPSAPUsers, NAME)}
              >
                Name
                <SortIconWrapper
                  value={NAME}
                  sortedByValue={sortedByValue}
                  shouldReverse={shouldReverse}
                />
              </UserTData>
            </UserContent>
            <UserContent>
              <UserTData
                clickable
                onClick={() => sortPSAPUsers(currentPSAPUsers, EMAIL)}
              >
                Email
                <SortIconWrapper
                  value={EMAIL}
                  sortedByValue={sortedByValue}
                  shouldReverse={shouldReverse}
                />
              </UserTData>
            </UserContent>
            <UserContent>
              <UserTData
                clickable
                onClick={() => sortPSAPUsers(currentPSAPUsers, ROLE)}
              >
                Role
                <SortIconWrapper
                  value={ROLE}
                  sortedByValue={sortedByValue}
                  shouldReverse={shouldReverse}
                />
              </UserTData>
            </UserContent>
            <UserContent>
              <UserTData
                clickable
                onClick={() => sortPSAPUsers(currentPSAPUsers, LAST_ACTIVE)}
              >
                <Box ellipsis>Last Active</Box>
                <SortIconWrapper
                  value={LAST_ACTIVE}
                  sortedByValue={sortedByValue}
                  shouldReverse={shouldReverse}
                />
              </UserTData>
            </UserContent>
            <UserContent>
              <UserTData flexEnd>
                <CustomToolTip isVisible={!!values.users.length}>
                  <TooltipChild>Resend invitation</TooltipChild>
                  <IconWrapper
                    clickable={!!values.users.length}
                    data-name="resend-invite-icon"
                  >
                    <PaperPlaneIcon
                      width={16}
                      height={16}
                      onClick={handleResentInvite}
                    />
                  </IconWrapper>
                </CustomToolTip>
                <IconWrapper
                  onClick={() => toggleDeleteUserModal(values)}
                  clickable={!!values.users.length}
                  lastIcon
                  data-name="delete-user-trash-bin-icon"
                >
                  <TrashBinIcon width={25} height={25} />
                </IconWrapper>
              </UserTData>
            </UserContent>
          </UserTHead>
          {currentPSAPUsers && currentPSAPUsers.length > 0 ? (
            <UsersList
              currentPSAPUsers={currentPSAPUsers}
              toggleEditUserModal={toggleEditUserModal}
              onCheckBoxChange={handleCheckboxChange}
              values={values}
              arrayHelpers={arrayHelpers}
            />
          ) : searchTerm ? (
            <NoSearchResult />
          ) : (
            <NoUsers />
          )}
        </UsersTable>
      </Container>
    );
  },
);

export default UsersContainer;
